import React from 'react';
import { Section } from './ui/Section';
import { PenTool, BrainCircuit, Crown, Smartphone, Zap, Crosshair } from 'lucide-react';
export function WhatYouGet() {
  const features = [{
    icon: <PenTool className="w-8 h-8" data-id="element-339" />,
    title: 'Diseño Web Estratégico de Alta Conversión',
    description: 'Una página construida desde cero para representarte con autoridad y convertir visitantes en clientes — no solo para verse bien.'
  }, {
    icon: <BrainCircuit className="w-8 h-8" data-id="element-340" />,
    title: 'Arquitectura de Persuasión',
    description: 'Cada sección, cada texto, cada llamado a la acción está diseñado estratégicamente para guiar a tu cliente ideal hacia contactarte a ti — y solo a ti.'
  }, {
    icon: <Crown className="w-8 h-8" data-id="element-341" />,
    title: 'Posicionamiento de Marca Profesional',
    description: 'Dejamos de ser "uno más del mercado" para posicionarte como el referente de tu nicho — el especialista al que la gente quiere acceder.'
  }, {
    icon: <Smartphone className="w-8 h-8" data-id="element-342" />,
    title: 'Optimización para Dispositivos Móviles',
    description: 'Más del 70% de tus clientes potenciales te visitan desde su celular. Tu web se verá perfecta en cualquier dispositivo.'
  }, {
    icon: <Zap className="w-8 h-8" data-id="element-343" />,
    title: 'Velocidad y Experiencia de Usuario',
    description: 'Una web lenta pierde clientes. La tuya cargará rápido y será fácil de navegar — porque cada segundo importa.'
  }, {
    icon: <Crosshair className="w-8 h-8" data-id="element-344" />,
    title: 'Estrategia de Diferenciación Competitiva',
    description: 'Identificamos exactamente qué te hace diferente de tu competencia y lo comunicamos de forma irresistible.'
  }];
  return <Section className="bg-[#0F1525]" data-id="element-345">
      <div className="max-w-6xl mx-auto" data-id="element-346">
        <div className="text-center mb-16" data-id="element-347">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-348">
            Lo Que Obtienes Cuando Trabajamos Juntos
          </h2>
          <p className="text-xl text-brand-accent font-medium" data-id="element-349">
            Esto no es solo una página web. Es tu nueva arma competitiva.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-350">
          {features.map((feature, index) => <div key={index} className="bg-brand-surface border border-white/5 p-8 rounded-2xl hover:border-brand-accent/30 transition-all hover:-translate-y-1 group" data-id="element-351">
              <div className="w-14 h-14 rounded-xl bg-brand-dark flex items-center justify-center text-brand-accent mb-6 group-hover:scale-110 transition-transform" data-id="element-352">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-353">
                {feature.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-354">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}